import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Swallow cross-origin "Script error." events from third-party embeds
// (e.g. TradingView widget scripts). These are opaque browser CORS
// notifications, not real app errors, but CRA's dev overlay treats them
// as uncaught runtime errors and covers the UI. We stop them at capture.
if (typeof window !== "undefined") {
  window.addEventListener(
    "error",
    (e) => {
      const msg = e?.message || "";
      const src = e?.filename || "";
      const isScriptError = msg === "Script error." || msg.includes("Script error");
      const isThirdParty =
        src.includes("tradingview.com") || src.includes("s3.tradingview.com");
      if (isScriptError || isThirdParty) {
        e.stopImmediatePropagation();
        e.preventDefault();
        return true;
      }
      return undefined;
    },
    true,
  );
  window.addEventListener("unhandledrejection", (e) => {
    const reason = String(e?.reason || "");
    if (reason.includes("tradingview") || reason.includes("Script error")) {
      e.preventDefault();
    }
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);


// Register the PWA service worker so the "Install app" prompt can appear.
// The SW only caches static assets — API responses are always fresh.
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
    window.addEventListener("load", () => {
        navigator.serviceWorker.register("/sw.js").catch(() => {
            // Silently ignore SW registration failures — the app works fine without it.
        });
    });
}
